import { render, staticRenderFns } from "./SplitTabs.vue?vue&type=template&id=49dcf13b&"
import script from "./SplitTabs.vue?vue&type=script&lang=js&"
export * from "./SplitTabs.vue?vue&type=script&lang=js&"
import style0 from "./SplitTabs.vue?vue&type=style&index=0&id=49dcf13b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider,VTooltip})
